import { useEffect, useMemo, useState } from "react";

const num = (value) => Number(String(value).replace(/[^\d.-]/g, ""));
const isNumeric = (value) => /^[-\d]/.test(String(value)) && !Number.isNaN(num(value));

// Search, filter and sort for the detail dialog tables.
export const useDetailRows = (detail, section) => {
  const [query, setQuery] = useState("");
  const [filter, setFilter] = useState("all");
  const [sort, setSort] = useState({ index: null, asc: true });

  useEffect(() => {
    setQuery("");
    setFilter("all");
    setSort({ index: null, asc: true });
  }, [section]);

  const rows = useMemo(() => {
    if (!detail) return [];
    let out = detail.rows;
    const active = (detail.filters || []).find((f) => f.key === filter);
    if (active) out = out.filter((row) => active.test(row));
    if (query.trim()) {
      const needle = query.trim().toLowerCase();
      out = out.filter((row) => row.some((cell) => String(cell).toLowerCase().includes(needle)));
    }
    if (sort.index !== null) {
      out = [...out].sort((a, b) => {
        const [x, y] = [a[sort.index], b[sort.index]];
        const diff = isNumeric(x) && isNumeric(y) ? num(x) - num(y) : String(x).localeCompare(String(y));
        return sort.asc ? diff : -diff;
      });
    }
    return out;
  }, [detail, query, filter, sort]);

  const toggleSort = (index) =>
    setSort((prev) => ({ index, asc: prev.index === index ? !prev.asc : true }));

  return { rows, query, setQuery, filter, setFilter, sort, toggleSort };
};
